import React, { memo } from "react";

const CustomCheckbox = ({ checked, onChange, disabled, ...props }) => {
  return (
    <label className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
    </label>
  );
};

export default memo(CustomCheckbox);
